export const isGoodTeam = (asiaHandicap = "") => {
  return asiaHandicap.includes("-");
};
